<template>
  <div class="loading">
    <img class="icon" src="../assets/image/load.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style scoped lang="less">
@import '../assets/css/zIndex.less';

.loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: @fullscreen_loading;
  .icon {
    width: 30px;
    height: 30px;
    padding: 4px;
    border-radius: 50%;
    background: #fff;
  }
}
</style>
